function initWidget(openWidget) {
  const cartWidget = getUniqueElement('#cart-widget');
  const openPopupBtn = getUniqueElement('#open-popup-button');
  if (!cartWidget || !openPopupBtn) return;

  let cartData = cartWidget.querySelector('[data-cart]')?.dataset?.cart;
  if (!cartData) return;

  else cartData = JSON.parse(cartData);
  const lastAddedProductName = cartData.find(item => item.type !== 'Accessories')?.title;
  const cartWidgetProductNames = cartWidget.querySelectorAll('.cart__widget__product-name');
  const lastAddedProduct = [...cartWidgetProductNames].find(item => {
    if (lastAddedProductName?.includes(item.innerText)) return true;
  });
  const closeBtns = cartWidget.querySelectorAll('.cart__widget__close-button');
  const removeProductBtns = cartWidget.querySelectorAll('.cart__widget__card-x');
  const tabButtons = cartWidget.querySelectorAll('.cart__widget__tab-button');
  const tabContents = cartWidget.querySelectorAll('.cart__widget__tab-content-item');
  const checkoutButtons = cartWidget?.querySelectorAll('.cart__widget__checkout-button');

  setDescriptionTextCount(tabContents);
  setActiveView(lastAddedProduct, tabButtons, tabContents);
  setEventListeners({ cartWidget, tabButtons, tabContents, openPopupBtn, closeBtns, removeProductBtns, checkoutButtons });

  if (lastAddedProduct) {
    if (openWidget) setActive(cartWidget, false);
    setActive(openPopupBtn, true);
  }

  if (!lastAddedProduct) {
    setActive(cartWidget, false);
    setActive(openPopupBtn, false);
  }
}

function setActive(element, enable) {
  if (enable) element.classList.add('active');
  if (!enable) element.classList.remove('active');
}

function setWidget(chosenElement, elements) {
  elements.forEach(function (el) {
    setActive(el, false);
  });

  setActive(chosenElement, true)
}

function getUniqueElement(elId) {
  const els = document.querySelectorAll(elId);
  let uniqueEl;
  els.forEach((el, index) => {
    if (index == 0) uniqueEl = el;
    if (index > 0) el.remove();
  })

  return uniqueEl;
}

function setDescriptionTextCount(tabContents) {
  tabContents.forEach(tabContent => {
    const emptyBoxes = tabContent.querySelectorAll('.empty')?.length;
    const desc = tabContent.querySelector('.cart__widget__description');
    if (!desc) return;

    const unlockOfferText = desc?.dataset?.unlockText || '';
    const text = desc?.innerText;
    const newText = emptyBoxes && text ? text.replace(/{{\s*count\s*}}/g, emptyBoxes) : unlockOfferText;
    desc.innerText = newText;
  });
}

function setActiveView(lastAddedProduct, tabButtons, tabContents) {
  if (!lastAddedProduct || !tabButtons.length || !tabContents.length) return
  const lastAddedTabContent = lastAddedProduct.closest('.cart__widget__tab-content-item');
  console.log('last added tab content', lastAddedTabContent, lastAddedProduct);
  const lastTabName = lastAddedTabContent?.id;
  const lastTabButton = lastAddedTabContent?.closest('.cart__widget__tab-content')?.previousElementSibling?.querySelector(`[data-tab-target="${lastTabName}"]`);

  if (lastTabButton) setWidget(lastTabButton, tabButtons);
  if (lastAddedTabContent) setWidget(lastAddedTabContent, tabContents);
}

function getProductData(formDataArray) {
  const productData = formDataArray.reduce((acc, [key, value]) => {
    // Extract the index (1, 2, 3) from the key
    const match = key.match(/items\[(\d+)]\[(id|quantity)]/);
    if (match) {
      // index is a number, field is 'id' or 'quantity'
      const [, index, field] = match;

      // Find or create the object for this index
      const existingItem = acc[index - 1] || { id: null, quantity: null };
      existingItem[field] = Number(value);

      // Add obj at the correct index
      acc[index - 1] = existingItem;
    }
    return acc;
  }, []);

  return productData;
}

async function addToCart(productData) {
  const requestBody = {
    items: productData
  };

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody),
    });

    const json = await response.json();
    if (json.items) return { success: true };
    else return { success: false, response: json.description };
  } catch (error) {
    return { success: false, response: error };
  }
}

function setEventListeners({ cartWidget, tabButtons, tabContents, openPopupBtn, closeBtns, removeProductBtns, checkoutButtons }) {
  const powerStepForm = cartWidget?.querySelector('#care-package-form');
  const acceptPowerStepBtn = cartWidget?.querySelector('.accept-power-step');
  const errorMessageContainer = cartWidget?.querySelector('.power-step-error-message ');

  powerStepForm?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target)
    const productData = getProductData(Array.from(formData));
    setActive(errorMessageContainer, false);
    acceptPowerStepBtn.classList.add('loading');
    const resp = await addToCart(productData);
    acceptPowerStepBtn.classList.remove('loading');

    if (resp?.success || resp?.response?.includes('You can\'t add more')) {
      window.location.href = "/checkout";
    } else {
      setActive(errorMessageContainer, true);
      errorMessageContainer.innerHTML = resp?.response;
    }
  });

  tabButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const targetId = button.dataset.tabTarget;
      const content = cartWidget.querySelector(`#${targetId}`);

      setWidget(button, tabButtons);
      setWidget(content, tabContents);
    });
  });

  removeProductBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const openCartBtn = document.querySelector('.cart__toggle[aria-expanded="false"]');
      if (openCartBtn) openCartBtn.click()

      const cartDrawer = document.querySelector('#cart-drawer');
      const productTitle = btn.dataset.productTitle;
      const removeButton = cartDrawer?.querySelector(`[data-item-title="${productTitle}"]`)?.querySelector('.cart__item__remove');
      if (removeButton) removeButton.click();
    })
  });

  checkoutButtons.forEach(checkoutBtn => {
    const mainWidgetContent = cartWidget.querySelector('.cart__widget__main-step');
    const powerStepContent = cartWidget.querySelector('.cart__widget__power-step');

    checkoutBtn.addEventListener('click', () => {
      const powerProdInCart = cartWidget?.querySelector('[data-power-prod-in-cart]');

      if (powerProdInCart) {
        window.location.href = "/checkout";
        return;
      }
      
      setActive(mainWidgetContent, false);
      setActive(powerStepContent, true);
    });
  });

  // Close widget when outside click
  document.addEventListener('click', e => {
    const clickTarget = e.target;
    const isOpenButton = clickTarget?.classList.contains('cart__open-button');
    !cartWidget.contains(clickTarget) && !isOpenButton && setActive(cartWidget, false);
  });

  openPopupBtn?.addEventListener('click', () => setActive(cartWidget, true));
  closeBtns.forEach(closeBtn => {
    closeBtn?.addEventListener('click', () => setActive(cartWidget, false));
  });
}

initWidget();

document.addEventListener('cart-widget:updated', (e) => {
  initWidget(e.detail.isSupposedToTriggerWidget);
});
